import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { userDetailsState } from 'store/userDetailsSlice';

// TODO Deprecate this file and use the logic from the userDetails slice
export const useStoreSubscriptionPlan = () => {
  const { role_id, currentStore } = useSelector(userDetailsState);
  const [storeSubscriptionPlan, setStoreSubscriptionPlan] = useState(0);

  const subscriptionLevelEnum = Object.freeze({
    free: 0,
    small_business: 1,
    growth: 2,
    unlimited: 3,
    enterprise: 3,
  });

  useEffect(() => {
    if (role_id === 1) {
      setStoreSubscriptionPlan(subscriptionLevelEnum.enterprise);
      return;
    }

    if (currentStore) {
      type Level = keyof typeof subscriptionLevelEnum;

      const level = currentStore?.completeInfo?.active_sub?.level
        .toLowerCase()
        .replace(' ', '_') as Level;

      setStoreSubscriptionPlan(subscriptionLevelEnum[level]);
    }
  }, [currentStore, role_id, subscriptionLevelEnum]);

  return { storeSubscriptionPlan, subscriptionPlans: subscriptionLevelEnum };
};
